<template>
    <div ref="imgElement" :class="componentClasses">
        <img
            v-if="avatarSource"
            class="avatar-icon__img"
            :src="avatarSource"
            :alt="assistent?.name"
        />
    </div>
</template>

<script setup lang="ts">
    import useConfiguration from '@/composables/useConfiguration';
    import { computed, ref } from 'vue';
    import { AvatarVariant } from '@keyvue/one-api-client';

    const props = withDefaults(defineProps<{ smaller: boolean, round: boolean }>(), {
        smaller: false,
        round: false,
    });

    const { assistent } = useConfiguration();
    const imgElement = ref();

    const componentClasses = computed(() => {
        return {
            'avatar-icon': true,
            'avatar-icon--smaller': props.smaller,
            'avatar-icon--round': props.round,
        };
    });

    const avatarSource = computed(() => {
        const variant = assistent.value?.avatarVariant;
        let prefix = '';

        // attempt to get the base url from the root node (when shadowRoot)
        const rootNode = imgElement.value?.closest('[data-base-url]');
        if (rootNode) {
            prefix = rootNode.getAttribute('data-base-url');
        }

        if (!variant) {
            return null;
        }

        if (AvatarVariant.CUSTOM.equals(variant)) {
            return assistent.value?.avatar?.url;
        }

        if (AvatarVariant.VARIANT1.equals(variant)) {
            return `${prefix}/avatars/1.png`;
        }

        if (AvatarVariant.VARIANT2.equals(variant)) {
            return `${prefix}/avatars/2.png`;
        }

        if (AvatarVariant.VARIANT3.equals(variant)) {
            return `${prefix}/avatars/3.png`;
        }

        return null;
    });
</script>

<style scoped lang="scss">
    .avatar-icon {
        width: 64px;
        height: 64px;
        border: solid 2px white;
        border-radius: 10px;
        overflow: hidden;
        flex-shrink: 0;

        &--smaller {
            width: 48px;
            height: 48px;
            border: solid 1px var(--color-widget);
            border-radius: 5px;
            padding: .1rem;
        }

        &--round {
            border-radius: 25px;
            padding: .1rem;
        }

        &__img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: inherit;
        }
    }
</style>
